import { render } from "./AdmMenu.vue?vue&type=template&id=e959b8c2"
import script from "./AdmMenu.vue?vue&type=script&lang=js"
export * from "./AdmMenu.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__